import { dt } from '../../util/dateTime';

interface UseShowLongFetchTimeIndicatorProps {
    isLinkingInProgress: boolean | undefined;
    lastUpdatedISO: string;
}

export const useShowLongFetchTimeIndicator = ({
    isLinkingInProgress,
    lastUpdatedISO,
}: UseShowLongFetchTimeIndicatorProps): boolean => {
    if (!isLinkingInProgress) {
        return false;
    }

    const minutesSinceLastUpdate = dt().diff(dt(lastUpdatedISO), 'minute');
    return minutesSinceLastUpdate > 1;
};
